export default "__VITE_ASSET__de43ebe5__"